"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _misc = _interopRequireDefault(require("../tokens/misc"));
var _CheckCircle = _interopRequireDefault(require("../Icons/all/CheckCircle"));
var _noop2 = _interopRequireDefault(require("lodash-es/noop"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _red = _interopRequireDefault(require("../tokens/color/red"));
var _grey = _interopRequireDefault(require("../tokens/color/grey"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var size = 26;
var spacing = 2;
var RadioSwitch = function RadioSwitch(_ref) {
  var onToggle = _ref.onToggle,
    readOnly = _ref.readOnly,
    active = _ref.active;
  var _useState = (0, _react.useState)(active),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    activeState = _useState2[0],
    toggleActiveState = _useState2[1];
  return /*#__PURE__*/_react["default"].createElement(RadioSwitch.wrapper, {
    onClick: function onClick() {
      onToggle(!activeState);
      return toggleActiveState(!activeState);
    }
  }, /*#__PURE__*/_react["default"].createElement(RadioSwitch.iconSpan, {
    on: activeState && !readOnly
  }, /*#__PURE__*/_react["default"].createElement(_CheckCircle["default"], {
    color: _red["default"].z500,
    size: size
  })), /*#__PURE__*/_react["default"].createElement(RadioSwitch.inactiveSpan, {
    on: !activeState || readOnly
  }));
};
RadioSwitch.wrapper = _styledComponents["default"].span.withConfig({
  componentId: "sc-aydqmy-0"
})(["display:inline-block;position:relative;cursor:pointer;width:", "rem;height:", "rem;appearance:none;outline:none;"], size / 10, size / 10);
RadioSwitch.inactiveSpan = _styledComponents["default"].span.withConfig({
  componentId: "sc-aydqmy-1"
})(["display:inline-block;position:absolute;appearance:none;top:0;left:0;width:100%;height:100%;border:", "rem ", " solid;border-radius:50%;transition:opacity ", ";opacity:", ";"], spacing / 10, _grey["default"].z400, _misc["default"].shortAnimDuration, function (props) {
  return props.on ? "1" : 0;
});
RadioSwitch.iconSpan = _styledComponents["default"].span.withConfig({
  componentId: "sc-aydqmy-2"
})(["display:inline-block;position:absolute;top:0;left:0;width:", "rem;appearance:none;height:", "rem;transition:opacity ", ";opacity:", ";"], size / 10, size / 10, _misc["default"].shortAnimDuration, function (props) {
  return props.on ? "1" : 0;
});
RadioSwitch.propTypes = {
  readOnly: _propTypes["default"].bool,
  size: _propTypes["default"].number,
  spacing: _propTypes["default"].number,
  onToggle: _propTypes["default"].func,
  active: _propTypes["default"].bool
};
RadioSwitch.defaultProps = {
  readOnly: false,
  size: 26,
  spacing: 2,
  onToggle: _noop2["default"]
};
var _default = exports["default"] = RadioSwitch;